import React from "react"
import { Container, Info, SpecialOffer, Contact } from "../styles/NewsStyle"
import PhoneIcon from "@mui/icons-material/Phone"
import PlaceIcon from "@mui/icons-material/Place"
const News = () => {
  return (
    <Container>
      <SpecialOffer>New Limited Edition</SpecialOffer>
      <Contact>
        <PhoneIcon />
        <Info>095 31 23 60</Info>
        <PlaceIcon />
        <Info>23 rue des oranges</Info>
      </Contact>
    </Container>
  )
}

export default News
